import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig() || {};

export const BUILD_ID = process.env.BUILD_ID || publicRuntimeConfig?.BUILD_ID;
export const ENVIRONMENT =
  process.env.ENVIRONMENT || publicRuntimeConfig?.ENVIRONMENT;
/*
  NODE_ENV: (dev or prod build) - test | development | production  
  ENVIRONMENT: (actual environment app is deployed to) - dev | sit | staging | production 
*/
export const isProd = ENVIRONMENT === 'production';

export const RELEASE = `qp-${BUILD_ID}-${ENVIRONMENT}`;

export const SANITY_PROJECT_ID =
  process.env.NEXT_PUBLIC_SANITY_PROJECT_ID ||
  process.env.NEXT__SANITY_PROJECT_ID ||
  publicRuntimeConfig.NEXT__SANITY_PROJECT_ID;
export const SANITY_DATASET =
  process.env.NEXT_PUBLIC_SANITY_DATASET ||
  process.env.NEXT__SANITY_DATASET ||
  publicRuntimeConfig.NEXT__SANITY_DATASET;

export const BASE_PATH =
  process.env.BASE_PATH || publicRuntimeConfig?.BASE_PATH || '';

export const NEXT__OPTIMIZELY_SDK_KEY =
  process.env.NEXT_PUBLIC_OPTIMIZELY_SDK_KEY ||
  process.env.NEXT__OPTIMIZELY_SDK_KEY ||
  publicRuntimeConfig.NEXT__OPTIMIZELY_SDK_KEY;

export const OPTIMIZELY_LOG_LEVEL =
  process.env.NEXT_PUBLIC_OPTIMIZELY_LOG_LEVEL ||
  process.env.NEXT__OPTIMIZELY_LOG_LEVEL ||
  publicRuntimeConfig?.NEXT__OPTIMIZELY_LOG_LEVEL ||
  (isProd ? 'warn' : 'error');
